import { createFileRoute } from "@tanstack/react-router";
import ImpressumPage from "@/pages/ImpressumPage";
import { buildRouteHead } from "@/lib/route-head";

export const Route = createFileRoute("/impressum")({
  head: () =>
    buildRouteHead({
      title: "Impressum | Goldhammer & Kerwel GbR Wernigerode",
      description:
        "Impressum der Agentur Enno & Jens – Goldhammer & Kerwel GbR. Kontaktdaten und rechtliche Angaben.",
      path: "/impressum",
    }),
  component: ImpressumPage,
});
